import { LOCALSTORAGEKEYS } from "../../common/constants";
import { getLink, sendCallToAPI } from "../../common/generic_functions";
import { links } from "./links";

export const validateUser = (store, dispatch) => {
  //   const powerBiExpiry = localStorage.getItem("reportExpireToken");
  //   const powerBiTokenStatus = new Date().getTime() >= parseInt(powerBiExpiry, 10);
  //   // const accessTokenExpiryTimeStatus = new Date().getTime() >= parseInt(accessTokenExpiryTime,10)
  //   if (powerBiTokenStatus) {
  //     localStorage.removeItem("accessToken");
  //     localStorage.removeItem("refreshToken");
  //     localStorage.removeItem("userData");
  //     localStorage.removeItem("ssoToken");
  //     localStorage.removeItem("reportExpireToken");
  //     window.location.href = "/login";
  //   }

  const ssoToken = store.ssoToken ?? localStorage.getItem(LOCALSTORAGEKEYS.SSOTOKEN);
  const token = store.accessToken ?? localStorage.getItem(LOCALSTORAGEKEYS.ACCESSTOKEN);
  if (token) {
    return token;
  } else if (ssoToken) {
    validateWithSSOToken(ssoToken, dispatch);
  }
  dispatch("CLEAR_DATA");
  return false;
};

const validateWithSSOToken = async (token, dispatch) => {
  const link = getLink("", links, "sso_validation");
  const data = await sendCallToAPI(link, "notoken", { token: token }, "POST");
  if (!data || !data.accessToken) {
    dispatch("CLEAR_DATA");
    return;
  }
  dispatch("SAVE_JWT_TOKEN", [data?.accessToken, data?.expiration, data?.refreshAccessToken, data?.ssoToken]);
  dispatch("SAVE_USERNAME", data?.userData?.username);
  dispatch("SAVE_USER", data?.userData);
  return data.accessToken;
};
